import React from "react"
import { Link } from "gatsby"
import { Rollover } from "./Rollover"

// Utility Functions
import { generatePageSpecificRows } from "../utils/generatePageSpecificRows"

// Custom Components
import { Winner } from "./Winner"

function Row(props) {
  const { featuredProjs, headline, rowPage } = props

  const rowsObj = generatePageSpecificRows({
    featuredProjs,
    rowPage,
  })

  const dataArr = []

  for (let i = 0; i < rowsObj.name.length; i += 1) {
    dataArr.push({
      name: rowsObj.name[i],
      image: rowsObj.image[i],
      type: rowsObj.type[i],
      pageLink: rowsObj.pageLink[i],
      pageLinkDesc: rowsObj.pageLinkDesc[i],
      winner: rowsObj.winner[i],
    })
  }

  function checkForData(arr) {
    if (arr.length !== 0) {
      return arr.map(proj => (
        <div key={proj.name.replace("&#038;", "&")} className="row__container">
          {rowPage === "portfolio" ? (
            <div className="row__images-container">
              <Link className="link link--noline" to={`/${proj.pageLink.match(/([^/]*)\/*$/)[1]}`}>
                <img className="row__image" src={proj.image.localFile.childImageSharp.fluid.src} alt={proj.name.replace("&#038;", "&")} />
                {proj.winner === "Yes" ? <Winner /> : ""}
              </Link>
            </div>
          ) : (
            <Link className="link" to={`/${proj.pageLink.match(/([^/]*)\/*$/)[1]}`}>
              <img className="row__image" src={proj.image.localFile.childImageSharp.fluid.src} alt={proj.name.replace("&#038;", "&")} />
            </Link>
          )}
          <div className="row__banner">
            <Rollover prependedSlug="projects" pageLink={`projects/${proj.pageLink}`} pageLinkCopy={proj.name.replace("&#038;", "&")} />
            <h5 className="row__type">{proj.type}</h5>
          </div>
        </div>
      ))
    }
    return <div className="row__container">Sorry, there are no projects to display for the selected filter.</div>
  }

  return (
    rowsObj.hasInfo && (
      <div className="row">
        <div className="row__wrapper">
          <h3 className="row__title">{headline}</h3>
          {checkForData(dataArr)}
        </div>
      </div>
    )
  )
}

export { Row }
